import React from 'react';
import { ClickableTextProps } from './interface';

export const ClickableText = ({ onClick, children, disabled, testId }: ClickableTextProps) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      style={{
        background: 'transparent',
        border: 'none',
        padding: 0,
        margin: 0,
        cursor: disabled ? 'default' : 'pointer',
      }}
    >
      {children}
    </button>
  );
};
